export const FIELDS = [
	'gender',
	'style',
	'age',
	'ethnic',
	'height',
	'physique',
	'boobs',
	'butt',
	'penisSize',
	'hairStyle',
	'hairColor',
	'eyeColor',
	'personality',
	'name',
	'orientation',
	'chatStyle',
	'occupation',
	'startingRelationship',
	'kinks',
] as const;

export const CUSTOM_VALUE_QUERY_PARAM_PREFIX = 'cu_';
export const CUSTOM_VALUE_QUERY_PARAM_VALUE = 'custom';
